import { keycloak } from '@/config';
import { logOutUser } from '@/clients/auth/samsungAccount';

export const kcInstance = async () => {
  if (!keycloak.canRefresh()) return null;
  const exp = keycloak.getExpireIn();
  if (33 > exp) {
    try {
      await keycloak.refreshToken(33);
    } catch (e) {
      logOutUser();
      return null;
    }
  }
  return keycloak.instance;
};
